import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';

const apiNestUrl = process.env.REACT_APP_OMS_NEST_API;

/* Queued export, same as the Service Orders report: the API returns as soon as
   the job is queued and the worker emails the file to the signed-in user, so
   there is no report link to redirect to. */
export const fetchDriverAnalysisExport = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const authUser = JSON.parse(localStorage.getItem('authUser') || '{}');
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/driver-analysis/export-driver-analysis`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      exportType: 'DriverAnalysis',
      dateFrom: params?.date_from || params?.dateFrom || '',
      dateTo: params?.date_to || params?.dateTo || '',
      // Transaction date range - filters created_at (capture time).
      createdFrom: params?.created_from || params?.createdFrom || '',
      createdTo: params?.created_to || params?.createdTo || '',
      country: params?.country || authUser?.country || 'ae',
      soNo: params?.so_no || params?.soNo || '',
      driverName: params?.driver_name || params?.driverName || '',
      dispatchLocation:
        params?.dispatch_location || params?.dispatchLocation || '',
      // 'rated' | 'non_rated' | '' (all)
      rating: params?.rating || '',
      format: (params?.format || 'xlsx').toLowerCase(),
      userId: authUser?.user_id || authUser?.id || '',
      email: authUser?.user_email || authUser?.email || '',
      name: authUser?.user_name || authUser?.name || '',
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return (
      error?.response?.data || { status: 'failed', message: 'Export failed' }
    );
  }
};

/* Distinct drivers / dispatch locations for the listing dropdowns. */
export const fetchDriverAnalysisFilterOptions = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/driver-analysis/filter-options`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return null;
  }
};

/* Aggregates behind the charts. Takes the same filter params as the listing, so
   the charts always describe the rows in the table below them. */
export const fetchDriverAnalysisSummary = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/driver-analysis/summary`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return null;
  }
};

export const fetchDriverAnalysisList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  const config = {
    method: 'POST',
    url: `${apiNestUrl}/driver-analysis/list`,
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      'Content-Type': 'application/json',
    },
    data: {
      ...params,
    },
  };
  try {
    const response = await axios(config);
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
    return null;
  }
};
